import styled from 'styled-components';

export const SignInButtonWrapper = styled.div`
  margin-top: 25px;
`;
